import React from 'react';
import Obligation from './Obligation';
import moment from 'moment';
import 'moment-timezone';

export default function ObligationMapper(props) {
    return (props.obligations.map((ob) => ob.estado !== 'JUDICIAL' ? <Obligation key={ob.id} obligation={ob}/> : null))
}